import { type OfferV11 } from '@redteclab/api/clients/bully'

import { apmCaptureError } from '../../../apm'

import { productAccessorGetBestOffer } from './productAccessorGetBestOffer'
import { productAccessorGetOfferById } from './productAccessorGetOfferById'
import { productAccessorGetSaeOffer } from './productAccessorGetSaeOffer'

class NoDefaultOfferError extends Error {
  public constructor(details?: string) {
    super(`NO_DEFAULT_OFFER: ${details}`)
    this.name = 'NoDefaultOfferError'
  }
}

const getFallbackOffer = (
  isMarketplace: boolean,
  offers: OfferV11[],
): OfferV11 | undefined => {
  if (isMarketplace) {
    return offers[0]
  }

  /**
   * https://jira.shop-apotheke.com/browse/WSAWA-5148
   * for non marketplace tenant return sae only,
   * otherwise during MP canary MP products may be shown if we just return offers[0]
   */
  return productAccessorGetSaeOffer({ offers })
}

const productAccessorGetDefaultOffer = (
  isMarketplace: boolean,
  offers: OfferV11[],
): OfferV11 | undefined => {
  if (isMarketplace) {
    const bestOffer = productAccessorGetBestOffer({ offers })
    if (!bestOffer) {
      apmCaptureError(new NoDefaultOfferError('no best offer for mp enabled'))

      return getFallbackOffer(isMarketplace, offers)
    }

    return bestOffer
  }

  return productAccessorGetSaeOffer({ offers })
}

export const productAccessorGetOfferByIdOrDefault = ({
  isMarketplace,
  offerId,
  offers,
}: {
  isMarketplace: boolean
  offerId?: string | null
  offers?: OfferV11[]
}): OfferV11 | undefined => {
  if (!offers?.length) {
    return undefined
  }

  if (!offerId) {
    return productAccessorGetDefaultOffer(isMarketplace, offers)
  }

  const offerById = productAccessorGetOfferById({ offerId, offers })

  if (!offerById) {
    return productAccessorGetDefaultOffer(isMarketplace, offers)
  }

  return offerById
}
